export const DropboxPluginId = '55a5d915446f517774210002';
export const DropboxClaimedHosts = [
  'dropbox.com',
  'www.dropbox.com',
  'paper.dropbox.com',
];
